import { t } from 'i18next';

export const ActRejectionGridPluginSettings = (): IPluginSettings => {
    let index = 0;
    return {
        name: t('documents.actRejection.gridPluginName'),
        mnemocode: 'act_rejection_plugin',
        permission: 'RejectionAct',
        columns: [
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'IdGlobal',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'contractorName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.contractorName'),
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'mnemocode',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.mnemocode'),
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'documentDate',
                propertyType: 'datetime',
                displayName: t('documents.actRejection.fields.documentDate'),
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'storeName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.storeName'),
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'itemsCount',
                propertyType: 'number',
                displayName: t('documents.actRejection.fields.itemsCount'),
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: t('documents.actRejection.fields.dateCreated'),
                visibility: true,
                width: 150
            }
        ]
    }
}